/* eslint react/prop-types: 0 */

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { InputFieldResponsive, InputFieldResponsive2 } from "../../component/Utils";
import { Loader, Button } from "semantic-ui-react";
import numeral from "numeral";
import { neraca as formula } from "../../utils/financeFormula";
import { toast } from "react-toastify";
import Table from 'react-bootstrap/Table';
import { rkapPercentage } from "../../utils/helper";

export const Neraca = (props) => {
  const user = useSelector((state) => state.main.dataUser);
  const reportReducer = useSelector((state) => state.reportReducer);
  const filter = useSelector((state) => state.main);

  const initialFixedAsset = { name: "", value: "" };

  const disabledInput = user.role < 4;
  const [dataInput, setdataInput] = useState({});
  const [fixedAssets, setFixedAssets] = useState([initialFixedAsset]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    const stringFields = ["catatan"];
    let v = value;
    if (stringFields.indexOf(name) < 0) v = parseInt(value);
    setdataInput({
      ...dataInput,
      [name]: v,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    props.postData(dataInput);
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   const data = {
  //     ...dataInput,
  //     fixedAssets: fixedAssets,
  //   };
  //   if (data.fixedAssets.length > 0) {
  //     for (const i in data.fixedAssets) {
  //       const fa = data.fixedAssets[i];
  //       if (fa.name.length === 0) {
  //         toast.error("Nama Fixed Asset tidak boleh kosong");
  //         return;
  //       }
  //       if (fa.value && fa.value < 0) {
  //         toast.error("Nilai Fixed Asset harus lebih dari nol");
  //         return;
  //       }
  //     }
  //   }
  //   props.postData(data);
  // };

  const handleAddFixed = () => {
    const newFixed = Object.assign([], fixedAssets);
    newFixed.push({
      name: "",
      value: "",
    });
    setFixedAssets(newFixed);
  };

  const handleRemoveFixed = (index) => {
    const newFixed = Object.assign([], fixedAssets);
    newFixed.splice(index, 1);
    setFixedAssets(newFixed);
  };

  const handleChangeFixed = (event, index) => {
    const { name, value } = event.target;
    const v = name === "value" ? value * 1 : value;
    const newFixed = Object.assign([], fixedAssets);
    newFixed[index] = { ...newFixed[index], [name]: v };
    setFixedAssets(newFixed);
  };

  useEffect(() => {
    const data = reportReducer.dataReport
      ? reportReducer.dataReport.content[0]
      : null;
    setdataInput({
      ...data,
      kas: data ? data.kas : null,
      piutang: data ? data.piutang : null,
      persediaan: data ? data.persediaan : null,
      accountPayable: data ? data.accountPayable : null,
      hutangJangkaPendek: data ? data.hutangJangkaPendek : null,
      hutangJangkaPanjang: data ? data.hutangJangkaPanjang : null,
      labaDitahan: data ? data.labaDitahan : null,
      modalDisetor: data ? data.modalDisetor : null,
      ekuitasLain: data ? data.ekuitasLain : null,

      // Aset Lancar
      investasiJangkaPendek: data ? data.investasiJangkaPendek : null,
      puPihakBerelasi: data ? data.puPihakBerelasi : null,
      puPihakKetiga: data ? data.puPihakKetiga : null,
      plPihakBerelasi: data ? data.plPihakBerelasi : null,
      plPihakKetiga: data ? data.plPihakKetiga : null,
      uangMukaOperasional: data ? data.uangMukaOperasional : null,
      pendapatanHarusDiterima: data ? data.pendapatanHarusDiterima : null,
      biayaDibayarDimuka: data ? data.biayaDibayarDimuka : null,
      pajakDibayarDimuka: data ? data.pajakDibayarDimuka : null,
      asetJaminan: data ? data.asetJaminan : null,
      asetLancarLainnya: data ? data.asetLancarLainnya : null,
      uangMukaProyek: data ? data.uangMukaProyek : null,
      pjpJatuhTempo: data ? data.pjpJatuhTempo : null,

      // Aset Tidak Lancar
      asetTetapBersih: data ? data.asetTetapBersih : null,
      asetTakBerwujud: data ? data.asetTakBerwujud : null,
      asetHakGuna: data ? data.asetHakGuna : null,
      asetTanahPengembangan: data ? data.asetTanahPengembangan : null,
      asetDalamPenyelesaian: data ? data.asetDalamPenyelesaian : null,
      pjpPihakBerelasi: data ? data.pjpPihakBerelasi : null,
      pjpPihakKetiga: data ? data.pjpPihakKetiga : null,
      umpAsetTetap: data ? data.umpAsetTetap : null,
      investasiJangkaPanjang: data ? data.investasiJangkaPanjang : null,
      investasiEntitasAsosiasi: data ? data.investasiEntitasAsosiasi : null,
      persediaanRealEstate: data ? data.persediaanRealEstate : null,
      propertiInvestasiBersih: data ? data.propertiInvestasiBersih : null,
      asetPajakTangguhan: data ? data.asetPajakTangguhan : null,
      taksiranRestitusiPajak: data ? data.taksiranRestitusiPajak : null,
      asetPengampunanPajak: data ? data.asetPengampunanPajak : null,
      cadanganImbalanKerja: data ? data.cadanganImbalanKerja : null,
      asetTidaklancarLainnya: data ? data.asetTidaklancarLainnya : null,
      jumlahAset: data ? data.jumlahAset : null,

      // Liabilitas Jangka Pendek
      utangBankPendek: data ? data.utangBankPendek : null,
      uuPihakBerelasi: data ? data.uuPihakBerelasi : null,
      uuPihakKetiga: data ? data.uuPihakKetiga : null,
      ulPihakBerelasi: data ? data.ulPihakBerelasi : null,
      ulPihakKetiga: data ? data.ulPihakKetiga : null,
      utangRetensiPendek: data ? data.utangRetensiPendek : null,
      utangPajak: data ? data.utangPajak : null,
      pddPendek: data ? data.pddPendek : null,
      utangDeviden: data ? data.utangDeviden : null,
      utangSewa: data ? data.utangSewa : null,
      biayaDibayarPendek: data ? data.biayaDibayarPendek : null,
      bubJatuhTempo: data ? data.bubJatuhTempo : null,
      liabilitasPendekLainnya: data ? data.liabilitasPendekLainnya : null,

      // Liabilitas Jangka Panjang
      utangBankPanjang: data ? data.utangBankPanjang : null,
      ulpPihakBerelasi: data ? data.ulpPihakBerelasi : null,
      ulpPihakKetiga: data ? data.ulpPihakKetiga : null,
      pddPanjang: data ? data.pddPanjang : null,
      pajakTangguhanNeraca: data ? data.pajakTangguhanNeraca : null,
      utangRetensiPanjang: data ? data.utangRetensiPanjang : null,
      biayaDibayarPanjang: data ? data.biayaDibayarPanjang : null,
      utangPembiayaanPanjang: data ? data.utangPembiayaanPanjang : null,
      liabilitasImbalanKerja: data ? data.liabilitasImbalanKerja : null,
      titipanPelepasanAset: data ? data.titipanPelepasanAset : null,
      utangLainPenyelesaian: data ? data.utangLainPenyelesaian : null,
      liabilitasPanjangLainnya: data ? data.liabilitasPanjangLainnya : null,

      // Ekuitas
      modalSaham: data ? data.modalSaham : null,
      tambahanModalDisetor: data ? data.tambahanModalDisetor : null,
      cadanganModal: data ? data.cadanganModal : null,
      telahDitentukanPenggunaan: data ? data.telahDitentukanPenggunaan : null,
      belumDitentukanPenggunaan: data ? data.belumDitentukanPenggunaan : null,
      penghasilanKomperhensifLain: data ? data.penghasilanKomperhensifLain : null,
      deviden: data ? data.deviden : null,
      komponenEkuitasLain: data ? data.komponenEkuitasLain : null,
      kepentinganNonPengendali: data ? data.kepentinganNonPengendali : null,
      jumlahLiabilitasEkuitas: data ? data.jumlahLiabilitasEkuitas : null,
      // RKAP
      rkapKas: data ? data.rkapKas : null,
      rkapPersediaan: data ? data.rkapPersediaan : null,
      rkapAsetLancarLainnya: data ? data.rkapAsetLancarLainnya : null,

      rkapInvestasiJangkaPendek: data ? data.rkapInvestasiJangkaPendek : null,
      rkapPuPihakBerelasi: data ? data.rkapPuPihakBerelasi : null,
      rkapPuPihakKetiga: data ? data.rkapPuPihakKetiga : null,
      rkapPlPihakBerelasi: data ? data.rkapPlPihakBerelasi : null,
      rkapPlPihakKetiga: data ? data.rkapPlPihakKetiga : null,
      rkapUangMukaOperasional: data ? data.rkapUangMukaOperasional : null,
      rkapUangMukaProyek: data ? data.rkapUangMukaProyek : null,
      rkapPendapatanHarusDiterima: data ? data.rkapPendapatanHarusDiterima : null,
      rkapBiayaDibayarDimuka: data ? data.rkapBiayaDibayarDimuka : null,
      rkapPajakDibayarDimuka: data ? data.rkapPajakDibayarDimuka : null,
      rkapAsetJaminan: data ? data.rkapAsetJaminan : null,
      rkapPjpJatuhTempo: data ? data.rkapPjpJatuhTempo : null,

      rkapAsetTetapBersih: data ? data.rkapAsetTetapBersih : null,
      rkapAsetTakBerwujud: data ? data.rkapAsetTakBerwujud : null,
      rkapAsetHakGuna: data ? data.rkapAsetHakGuna : null,
      rkapAsetTanahPengembangan: data ? data.rkapAsetTanahPengembangan : null,
      rkapAsetDalamPenyelesaian: data ? data.rkapAsetDalamPenyelesaian : null,
      rkapPjpPihakBerelasi: data ? data.rkapPjpPihakBerelasi : null,
      rkapPjpPihakKetiga: data ? data.rkapPjpPihakKetiga : null,
      rkapUmpAsetTetap: data ? data.rkapUmpAsetTetap : null,
      rkapInvestasiJangkaPanjang: data ? data.rkapInvestasiJangkaPanjang : null,
      rkapInvestasiEntitasAsosiasi: data ? data.rkapInvestasiEntitasAsosiasi : null,
      rkapPersediaanRealEstate: data ? data.rkapPersediaanRealEstate : null,
      rkapPropertiInvestasiBersih: data ? data.rkapPropertiInvestasiBersih : null,
      rkapAsetPajakTangguhan: data ? data.rkapAsetPajakTangguhan : null,
      rkapTaksiranRestitusiPajak: data ? data.rkapTaksiranRestitusiPajak : null,
      rkapAsetPengampunanPajak: data ? data.rkapAsetPengampunanPajak : null,
      rkapCadanganImbalanKerja: data ? data.rkapCadanganImbalanKerja : null,
      rkapFixedAsetLainnya: data ? data.rkapFixedAsetLainnya : null,
      rkapAsetTidaklancarLainnya: data ? data.rkapAsetTidaklancarLainnya : null,

      rkapUtangBankPendek: data ? data.rkapUtangBankPendek : null,
      rkapUuPihakBerelasi: data ? data.rkapUuPihakBerelasi : null,
      rkapUuPihakKetiga: data ? data.rkapUuPihakKetiga : null,
      rkapUlPihakBerelasi: data ? data.rkapUlPihakBerelasi : null,
      rkapUlPihakKetiga: data ? data.rkapUlPihakKetiga : null,
      rkapUtangRetensiPendek: data ? data.rkapUtangRetensiPendek : null,
      rkapUtangPajak: data ? data.rkapUtangPajak : null,
      rkapPddPendek: data ? data.rkapPddPendek : null,
      rkapUtangDeviden: data ? data.rkapUtangDeviden : null,
      rkapUtangSewa: data ? data.rkapUtangSewa : null,
      rkapBiayaDibayarPendek: data ? data.rkapBiayaDibayarPendek : null,
      rkapBubJatuhTempo: data ? data.rkapBubJatuhTempo : null,
      rkapLiabilitasPendekLainnya: data ? data.rkapLiabilitasPendekLainnya : null,

      rkapUtangBankPanjang: data ? data.rkapUtangBankPanjang : null,
      rkapUlpPihakBerelasi: data ? data.rkapUlpPihakBerelasi : null,
      rkapUlpPihakKetiga: data ? data.rkapUlpPihakKetiga : null,
      rkapPddPanjang: data ? data.rkapPddPanjang : null,
      rkapPajakTangguhanNeraca: data ? data.rkapPajakTangguhanNeraca : null,
      rkapUtangRetensiPanjang: data ? data.rkapUtangRetensiPanjang : null,
      rkapBiayaDibayarPanjang: data ? data.rkapBiayaDibayarPanjang : null,
      rkapUtangPembiayaanPanjang: data ? data.rkapUtangPembiayaanPanjang : null,
      rkapLiabilitasImbalanKerja: data ? data.rkapLiabilitasImbalanKerja : null,
      rkapTitipanPelepasanAset: data ? data.rkapTitipanPelepasanAset : null,
      rkapUtangLainPenyelesaian: data ? data.rkapUtangLainPenyelesaian : null,
      rkapLiabilitasPanjangLainnya: data ? data.rkapLiabilitasPanjangLainnya : null,

      rkapModalSaham: data ? data.rkapModalSaham : null,
      rkapTambahanModalDisetor: data ? data.rkapTambahanModalDisetor : null,
      rkapCadanganModal: data ? data.rkapCadanganModal : null,
      rkapSaldoLabaRugi: data ? data.rkapSaldoLabaRugi : null,
      rkapTelahDitentukanPenggunaan: data ? data.rkapTelahDitentukanPenggunaan : null,
      rkapBelumDitentukanPenggunaan: data ? data.rkapBelumDitentukanPenggunaan : null,
      rkapPenghasilanKomperhensifLain: data ? data.rkapPenghasilanKomperhensifLain : null,
      rkapDeviden: data ? data.rkapDeviden : null,
      rkapKomponenEkuitasLain: data ? data.rkapKomponenEkuitasLain : null,
      rkapKepentinganNonPengendali: data ? data.rkapKepentinganNonPengendali : null,

    });
    const ifa = user.role < 4 ? [] : [initialFixedAsset];
    let fa = data?.fixedAssets || [];
    if (fa.length === 0) fa = undefined;
    setFixedAssets(fa || ifa);
  }, [reportReducer.dataReport]);

  if (reportReducer.isLoading) {
    return (
      <div className="w-100 d-flex justify-content-center">
        <Loader active>Loading</Loader>
      </div>
    );
  }
  return (
    <>
      <h3>
        Neraca - {filter.labelMonth} {filter.yearFilter}
      </h3>

      <Table bordereless hover>
        <thead>
          <tr>
            <td></td>
            <th width={"33%"}>Realisasi</th>
            <th width={"34%"}>RKAP</th>
            <th width={"5%"}>%</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>ASET LANCAR</th>
          </tr>
          <tr>
            <td>kas dan Setara Kas</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kas,
                  name: "kas",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapKas,
                  name: "rkapKas",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>{rkapPercentage(dataInput.kas, dataInput.rkapKas)}</td>
          </tr>
          <tr>
            <td>Investasi / Surat Berharga Jangka Pendek</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.investasiJangkaPendek,
                  name: "investasiJangkaPendek",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapInvestasiJangkaPendek,
                  name: "rkapInvestasiJangkaPendek",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.investasiJangkaPendek,
                dataInput.rkapInvestasiJangkaPendek
              )}
            </td>
          </tr>
          <tr>
            <th>Piutang Usaha</th>
          </tr>
          <tr>
            <td>Pihak Berelasi</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.puPihakBerelasi,
                  name: "puPihakBerelasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPuPihakBerelasi,
                  name: "rkapPuPihakBerelasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.puPihakBerelasi,
                dataInput.rkapPuPihakBerelasi
              )}
            </td>
          </tr>
          <tr>
            <td>Pihak Ketiga</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.puPihakKetiga,
                  name: "puPihakKetiga",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPuPihakKetiga,
                  name: "rkapPuPihakKetiga",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.puPihakKetiga,
                dataInput.rkapPuPihakKetiga
              )}
            </td>
          </tr>
          <tr>
            <th>Piutang Lain lain</th>
          </tr>
          <tr>
            <td>Pihak Berelasi</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.plPihakBerelasi,
                  name: "plPihakBerelasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPlPihakBerelasi,
                  name: "rkapPlPihakBerelasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.plPihakBerelasi,
                dataInput.rkapPlPihakBerelasi
              )}
            </td>
          </tr>
          <tr>
            <td>Pihak Ketiga</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.plPihakKetiga,
                  name: "plPihakKetiga",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPlPihakKetiga,
                  name: "rkapPlPihakKetiga",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.plPihakKetiga,
                dataInput.rkapPlPihakKetiga
              )}
            </td>
          </tr>
          <tr>
            <td>Persediaan</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.persediaan,
                  name: "persediaan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPersediaan,
                  name: "rkapPersediaan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(dataInput.persediaan, dataInput.rkapPersediaan)}
            </td>
          </tr>
          <tr>
            <td>Uang Muka Operasional</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.uangMukaOperasional,
                  name: "uangMukaOperasional",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapUangMukaOperasional,
                  name: "rkapUangMukaOperasional",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.uangMukaOperasional,
                dataInput.rkapUangMukaOperasional
              )}
            </td>
          </tr>
          <tr>
            <td>Uang Muka Proyek</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.uangMukaProyek,
                  name: "uangMukaProyek",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapUangMukaProyek,
                  name: "rkapUangMukaProyek",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.uangMukaProyek,
                dataInput.rkapUangMukaProyek
              )}
            </td>
          </tr>
          <tr>
            <td>Pendapatan yang Masih Harus Diterima</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.pendapatanHarusDiterima,
                  name: "pendapatanHarusDiterima",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPendapatanHarusDiterima,
                  name: "rkapPendapatanHarusDiterima",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.pendapatanHarusDiterima,
                dataInput.rkapPendapatanHarusDiterima
              )}
            </td>
          </tr>
          <tr>
            <td>Biaya Dibayar Dimuka</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.biayaDibayarDimuka,
                  name: "biayaDibayarDimuka",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapBiayaDibayarDimuka,
                  name: "rkapBiayaDibayarDimuka",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.biayaDibayarDimuka,
                dataInput.rkapBiayaDibayarDimuka
              )}
            </td>
          </tr>
          <tr>
            <td>Pajak Dibayar Dimuka</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.pajakDibayarDimuka,
                  name: "pajakDibayarDimuka",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPajakDibayarDimuka,
                  name: "rkapPajakDibayarDimuka",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.pajakDibayarDimuka,
                dataInput.rkapPajakDibayarDimuka
              )}
            </td>
          </tr>
          <tr>
            <td>Aset Jaminan</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.asetJaminan,
                  name: "asetJaminan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapAsetJaminan,
                  name: "rkapAsetJaminan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(dataInput.asetJaminan, dataInput.rkapAsetJaminan)}
            </td>
          </tr>
          <tr>
            <td>Bagian Piutang Jangka Panjang yang Akan Jatuh Tempo</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.pjpJatuhTempo,
                  name: "pjpJatuhTempo",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPjpJatuhTempo,
                  name: "rkapPjpJatuhTempo",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.pjpJatuhTempo,
                dataInput.rkapPjpJatuhTempo
              )}
            </td>
          </tr>
          <tr>
            <td>Aset Lancar Lainnya</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.asetLancarLainnya,
                  name: "asetLancarLainnya",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapAsetLancarLainnya,
                  name: "rkapAsetLancarLainnya",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.asetLancarLainnya,
                dataInput.rkapAsetLancarLainnya
              )}
            </td>
          </tr>
          <tr>
            <th>Jumlah Aset Lancar</th>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.currentAsset(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkapCurrentAsset(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              {rkapPercentage(
                formula.currentAsset(dataInput),
                formula.rkapCurrentAsset(dataInput)
              )}
            </td>
          </tr>
          <tr>
            <th>ASET TIDAK LANCAR</th>
          </tr>
          <tr>
            <td>Aset Tetap - Bersih</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.asetTetapBersih,
                  name: "asetTetapBersih",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapAsetTetapBersih,
                  name: "rkapAsetTetapBersih",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.asetTetapBersih,
                dataInput.rkapAsetTetapBersih
              )}
            </td>
          </tr>
          <tr>
            <td>Aset Tak Berwujud</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.asetTakBerwujud,
                  name: "asetTakBerwujud",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapAsetTakBerwujud,
                  name: "rkapAsetTakBerwujud",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.asetTakBerwujud,
                dataInput.rkapAsetTakBerwujud
              )}
            </td>
          </tr>
          <tr>
            <td>Aset Hak Guna</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.asetHakGuna,
                  name: "asetHakGuna",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapAsetHakGuna,
                  name: "rkapAsetHakGuna",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(dataInput.asetHakGuna, dataInput.rkapAsetHakGuna)}
            </td>
          </tr>
          <tr>
            <td>Aset Tanah dalam Pengembangan</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.asetTanahPengembangan,
                  name: "asetTanahPengembangan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapAsetTanahPengembangan,
                  name: "rkapAsetTanahPengembangan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.asetTanahPengembangan,
                dataInput.rkapAsetTanahPengembangan
              )}
            </td>
          </tr>
          <tr>
            <td>Aset Dalam Penyelesaian</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.asetDalamPenyelesaian,
                  name: "asetDalamPenyelesaian",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapAsetDalamPenyelesaian,
                  name: "rkapAsetDalamPenyelesaian",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.asetDalamPenyelesaian,
                dataInput.rkapAsetDalamPenyelesaian
              )}
            </td>
          </tr>
          <tr>
            <td>Piutang Jangka Panjang</td>
          </tr>
          <tr>
            <td>Pihak Berelasi</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.pjpPihakBerelasi,
                  name: "pjpPihakBerelasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPjpPihakBerelasi,
                  name: "rkapPjpPihakBerelasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.pjpPihakBerelasi,
                dataInput.rkapPjpPihakBerelasi
              )}
            </td>
          </tr>
          <tr>
            <td>Pihak Ketiga</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.pjpPihakKetiga,
                  name: "pjpPihakKetiga",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPjpPihakKetiga,
                  name: "rkapPjpPihakKetiga",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.pjpPihakKetiga,
                dataInput.rkapPjpPihakKetiga
              )}
            </td>
          </tr>
          <tr>
            <td>Uang Muka Pembelian Aset Tetap</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.umpAsetTetap,
                  name: "umpAsetTetap",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapUmpAsetTetap,
                  name: "rkapUmpAsetTetap",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.umpAsetTetap,
                dataInput.rkapUmpAsetTetap
              )}
            </td>
          </tr>
          <tr>
            <td>Investasi Jangka Panjang</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.investasiJangkaPanjang,
                  name: "investasiJangkaPanjang",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapInvestasiJangkaPanjang,
                  name: "rkapInvestasiJangkaPanjang",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.investasiJangkaPanjang,
                dataInput.rkapInvestasiJangkaPanjang
              )}
            </td>
          </tr>
          <tr>
            <td>Investasi pada Entitas Asosiasi</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.investasiEntitasAsosiasi,
                  name: "investasiEntitasAsosiasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapInvestasiEntitasAsosiasi,
                  name: "rkapInvestasiEntitasAsosiasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.investasiEntitasAsosiasi,
                dataInput.rkapInvestasiEntitasAsosiasi
              )}
            </td>
          </tr>
          <tr>
            <td>Persediaan Real Estate</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.persediaanRealEstate,
                  name: "persediaanRealEstate",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPersediaanRealEstate,
                  name: "rkapPersediaanRealEstate",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.persediaanRealEstate,
                dataInput.rkapPersediaanRealEstate
              )}
            </td>
          </tr>
          <tr>
            <td>Properti Investasi - Bersih</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.propertiInvestasiBersih,
                  name: "propertiInvestasiBersih",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPropertiInvestasiBersih,
                  name: "rkapPropertiInvestasiBersih",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.propertiInvestasiBersih,
                dataInput.rkapPropertiInvestasiBersih
              )}
            </td>
          </tr>
          <tr>
            <td>Aset Pajak Tangguhan</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.asetPajakTangguhan,
                  name: "asetPajakTangguhan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapAsetPajakTangguhan,
                  name: "rkapAsetPajakTangguhan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.asetPajakTangguhan,
                dataInput.rkapAsetPajakTangguhan
              )}
            </td>
          </tr>
          <tr>
            <td>Taksiran Tagihan Restitusi Pajak</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.taksiranRestitusiPajak,
                  name: "taksiranRestitusiPajak",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapTaksiranRestitusiPajak,
                  name: "rkapTaksiranRestitusiPajak",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.taksiranRestitusiPajak,
                dataInput.rkapTaksiranRestitusiPajak
              )}
            </td>
          </tr>
          <tr>
            <td>Aset Pengampunan Pajak</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.asetPengampunanPajak,
                  name: "asetPengampunanPajak",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapAsetPengampunanPajak,
                  name: "rkapAsetPengampunanPajak",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.asetPengampunanPajak,
                dataInput.rkapAsetPengampunanPajak
              )}
            </td>
          </tr>
          <tr>
            <td>Cadangan Imbalan Pasca Kerja</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.cadanganImbalanKerja,
                  name: "cadanganImbalanKerja",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapCadanganImbalanKerja,
                  name: "rkapCadanganImbalanKerja",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.cadanganImbalanKerja,
                dataInput.rkapCadanganImbalanKerja
              )}
            </td>
          </tr>
          <tr>
            <td>Aset Tidak Lancar Lainnya</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.asetTidaklancarLainnya,
                  name: "asetTidaklancarLainnya",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapAsetTidaklancarLainnya,
                  name: "rkapAsetTidaklancarLainnya",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.asetTidaklancarLainnya,
                dataInput.rkapAsetTidaklancarLainnya
              )}
            </td>
          </tr>
          <tr>
            <th>Jumlah Aset Tidak Lancar</th>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.fixedAsset(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkapFixedAsset(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              {rkapPercentage(
                formula.fixedAsset(dataInput),
                formula.rkapFixedAsset(dataInput)
              )}
            </td>
          </tr>
          <tr>
            <th>JUMLAH ASET</th>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.jumlahAset(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkapJumlahAset(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              {rkapPercentage(
                formula.jumlahAset(dataInput),
                formula.rkapJumlahAset(dataInput)
              )}
            </td>
          </tr>
          <tr>
            <th>LIABILITAS JANGKA PENDEK</th>
          </tr>
          <tr>
            <td>Utang Bank Jangka Pendek</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.utangBankPendek,
                  name: "utangBankPendek",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapUtangBankPendek,
                  name: "rkapUtangBankPendek",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.utangBankPendek,
                dataInput.rkapUtangBankPendek
              )}
            </td>
          </tr>
          <tr>
            <td>Utang Usaha</td>
          </tr>
          <tr>
            <td>Pihak Berelasi</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.uuPihakBerelasi,
                  name: "uuPihakBerelasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapUuPihakBerelasi,
                  name: "rkapUuPihakBerelasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.uuPihakBerelasi,
                dataInput.rkapUuPihakBerelasi
              )}
            </td>
          </tr>
          <tr>
            <td>Pihak Ketiga</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.uuPihakKetiga,
                  name: "uuPihakKetiga",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapUuPihakKetiga,
                  name: "rkapUuPihakKetiga",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.uuPihakKetiga,
                dataInput.rkapUuPihakKetiga
              )}
            </td>
          </tr>
          <tr>
            <td>Utang Lain-lain</td>
          </tr>
          <tr>
            <td>Pihak Berelasi</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.ulPihakBerelasi,
                  name: "ulPihakBerelasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapUlPihakBerelasi,
                  name: "rkapUlPihakBerelasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.ulPihakBerelasi,
                dataInput.rkapUlPihakBerelasi
              )}
            </td>
          </tr>
          <tr>
            <td>Pihak Ketiga</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.ulPihakKetiga,
                  name: "ulPihakKetiga",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapUlPihakKetiga,
                  name: "rkapUlPihakKetiga",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.ulPihakKetiga,
                dataInput.rkapUlPihakKetiga
              )}
            </td>
          </tr>
          <tr>
            <td>Utang Retensi Jangka Pendek</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.utangRetensiPendek,
                  name: "utangRetensiPendek",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapUtangRetensiPendek,
                  name: "rkapUtangRetensiPendek",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.utangRetensiPendek,
                dataInput.rkapUtangRetensiPendek
              )}
            </td>
          </tr>
          <tr>
            <td>Utang Pajak </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.utangPajak,
                  name: "utangPajak",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapUtangPajak,
                  name: "rkapUtangPajak",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(dataInput.utangPajak, dataInput.rkapUtangPajak)}
            </td>
          </tr>
          <tr>
            <td>Pendapatan Diterima Dimuka Jangka Pendek</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.pddPendek,
                  name: "pddPendek",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPddPendek,
                  name: "rkapPddPendek",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(dataInput.pddPendek, dataInput.rkapPddPendek)}
            </td>
          </tr>
          <tr>
            <td>Utang Dividen</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.utangDeviden,
                  name: "utangDeviden",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapUtangDeviden,
                  name: "rkapUtangDeviden",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.utangDeviden,
                dataInput.rkapUtangDeviden
              )}
            </td>
          </tr>
          <tr>
            <td>Utang Sewa</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.utangSewa,
                  name: "utangSewa",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapUtangSewa,
                  name: "rkapUtangSewa",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(dataInput.utangSewa, dataInput.rkapUtangSewa)}
            </td>
          </tr>
          <tr>
            <td>Biaya yang Masih Harus Dibayar Jangka Pendek</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.biayaDibayarPendek,
                  name: "biayaDibayarPendek",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapBiayaDibayarPendek,
                  name: "rkapBiayaDibayarPendek",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.biayaDibayarPendek,
                dataInput.rkapBiayaDibayarPendek
              )}
            </td>
          </tr>
          <tr>
            <td>Bagian Utang Bank yang Akan Jatuh Tempo</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.bubJatuhTempo,
                  name: "bubJatuhTempo",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapBubJatuhTempo,
                  name: "rkapBubJatuhTempo",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.bubJatuhTempo,
                dataInput.rkapBubJatuhTempo
              )}
            </td>
          </tr>
          <tr>
            <td>Liabilitas Jangka Pendek Lainnya</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.liabilitasPendekLainnya,
                  name: "liabilitasPendekLainnya",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapLiabilitasPendekLainnya,
                  name: "rkapLiabilitasPendekLainnya",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.liabilitasPendekLainnya,
                dataInput.rkapLiabilitasPendekLainnya
              )}
            </td>
          </tr>
          <tr>
            <th>Jumlah Liabilitas Jangka Pendek</th>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.liabilitasJangkaPendek(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkapLiabilitasJangkaPendek(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              {rkapPercentage(
                formula.liabilitasJangkaPendek(dataInput),
                formula.rkapLiabilitasJangkaPendek(dataInput)
              )}
            </td>
          </tr>
          <tr>
            <th>LIABILITAS JANGKA PANJANG</th>
          </tr>
          <tr>
            <td>Utang Bank Jangka Panjang</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.utangBankPanjang,
                  name: "utangBankPanjang",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapUtangBankPanjang,
                  name: "rkapUtangBankPanjang",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.utangBankPanjang,
                dataInput.rkapUtangBankPanjang
              )}
            </td>
          </tr>
          <tr>
            <td>Utang Lain-lain</td>
          </tr>
          <tr>
            <td>Pihak Berelasi</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.ulpPihakBerelasi,
                  name: "ulpPihakBerelasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapUlpPihakBerelasi,
                  name: "rkapUlpPihakBerelasi",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.ulpPihakBerelasi,
                dataInput.rkapUlpPihakBerelasi
              )}
            </td>
          </tr>
          <tr>
            <td>Pihak Ketiga</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.ulpPihakKetiga,
                  name: "ulpPihakKetiga",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapUlpPihakKetiga,
                  name: "rkapUlpPihakKetiga",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.ulpPihakKetiga,
                dataInput.rkapUlpPihakKetiga
              )}
            </td>
          </tr>
          <tr>
            <td>Pendapatan Diterima Dimuka Jangka Panjang</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.pddPanjang,
                  name: "pddPanjang",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPddPanjang,
                  name: "rkapPddPanjang",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(dataInput.pddPanjang, dataInput.rkapPddPanjang)}
            </td>
          </tr>
          <tr>
            <td>Pajak Tangguhan</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.pajakTangguhanNeraca,
                  name: "pajakTangguhanNeraca",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPajakTangguhanNeraca,
                  name: "rkapPajakTangguhanNeraca",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.pajakTangguhanNeraca,
                dataInput.rkapPajakTangguhanNeraca
              )}
            </td>
          </tr>
          <tr>
            <td>Utang Retensi Jangka Panjang</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.utangRetensiPanjang,
                  name: "utangRetensiPanjang",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapUtangRetensiPanjang,
                  name: "rkapUtangRetensiPanjang",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.utangRetensiPanjang,
                dataInput.rkapUtangRetensiPanjang
              )}
            </td>
          </tr>
          <tr>
            <td>Biaya yang Masih Harus Dibayar Jangka Panjang</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.biayaDibayarPanjang,
                  name: "biayaDibayarPanjang",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapBiayaDibayarPanjang,
                  name: "rkapBiayaDibayarPanjang",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.biayaDibayarPanjang,
                dataInput.rkapBiayaDibayarPanjang
              )}
            </td>
          </tr>
          <tr>
            <td>Utang Pembiayaan Jangka Panjang</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.utangPembiayaanPanjang,
                  name: "utangPembiayaanPanjang",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapUtangPembiayaanPanjang,
                  name: "rkapUtangPembiayaanPanjang",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.utangPembiayaanPanjang,
                dataInput.rkapUtangPembiayaanPanjang
              )}
            </td>
          </tr>
          <tr>
            <td>Liabilitas Imbalan Pasca Kerja</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.liabilitasImbalanKerja,
                  name: "liabilitasImbalanKerja",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapLiabilitasImbalanKerja,
                  name: "rkapLiabilitasImbalanKerja",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.liabilitasImbalanKerja,
                dataInput.rkapLiabilitasImbalanKerja
              )}
            </td>
          </tr>
          <tr>
            <td>Titipan Dana Pelepasan Aset</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.titipanPelepasanAset,
                  name: "titipanPelepasanAset",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapTitipanPelepasanAset,
                  name: "rkapTitipanPelepasanAset",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.titipanPelepasanAset,
                dataInput.rkapTitipanPelepasanAset
              )}
            </td>
          </tr>
          <tr>
            <td>Utang Lain-lain Dalam Penyelesaian</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.utangLainPenyelesaian,
                  name: "utangLainPenyelesaian",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapUtangLainPenyelesaian,
                  name: "rkapUtangLainPenyelesaian",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.utangLainPenyelesaian,
                dataInput.rkapUtangLainPenyelesaian
              )}
            </td>
          </tr>
          <tr>
            <td>Liabilitas Jangka Panjang Lainnya</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.liabilitasPanjangLainnya,
                  name: "liabilitasPanjangLainnya",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapLiabilitasPanjangLainnya,
                  name: "rkapLiabilitasPanjangLainnya",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.liabilitasPanjangLainnya,
                dataInput.rkapLiabilitasPanjangLainnya
              )}
            </td>
          </tr>
          <tr>
            <th>Jumlah Liabilitas Jangka Panjang</th>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.liabilitasJangkaPanjang(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkapLiabilitasJangkaPanjang(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              {rkapPercentage(
                formula.liabilitasJangkaPanjang(dataInput),
                formula.rkapLiabilitasJangkaPanjang(dataInput)
              )}
            </td>
          </tr>
          <tr>
            <th>JUMLAH LIABILITAS</th>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.liabilitas(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkapLiabilitas(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              {rkapPercentage(
                formula.liabilitas(dataInput),
                formula.rkapLiabilitas(dataInput)
              )}
            </td>
          </tr>
          <tr>
            <th>EKUITAS</th>
          </tr>
          <tr>
            <td>Modal Saham</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.modalSaham,
                  name: "modalSaham",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapModalSaham,
                  name: "rkapModalSaham",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(dataInput.modalSaham, dataInput.rkapModalSaham)}
            </td>
          </tr>
          <tr>
            <td>Tambahan Modal Disetor</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.tambahanModalDisetor,
                  name: "tambahanModalDisetor",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapTambahanModalDisetor,
                  name: "rkapTambahanModalDisetor",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.tambahanModalDisetor,
                dataInput.rkapTambahanModalDisetor
              )}
            </td>
          </tr>
          <tr>
            <td>Cadangan Modal</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.cadanganModal,
                  name: "cadanganModal",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapCadanganModal,
                  name: "rkapCadanganModal",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.cadanganModal,
                dataInput.rkapCadanganModal
              )}
            </td>
          </tr>
          <tr>
            <td>Saldo Laba (Rugi)</td>
          </tr>
          <tr>
            <td>Telah Ditentukan Penggunaannya</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.telahDitentukanPenggunaan,
                  name: "telahDitentukanPenggunaan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapTelahDitentukanPenggunaan,
                  name: "rkapTelahDitentukanPenggunaan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.telahDitentukanPenggunaan,
                dataInput.rkapTelahDitentukanPenggunaan
              )}
            </td>
          </tr>
          <tr>
            <td>Belum Ditentukan Penggunaannya</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.belumDitentukanPenggunaan,
                  name: "belumDitentukanPenggunaan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapBelumDitentukanPenggunaan,
                  name: "rkapBelumDitentukanPenggunaan",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.belumDitentukanPenggunaan,
                dataInput.rkapBelumDitentukanPenggunaan
              )}
            </td>
          </tr>
          <tr>
            <td>Penghasilan Komprehensif Lain</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.penghasilanKomperhensifLain,
                  name: "penghasilanKomperhensifLain",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapPenghasilanKomperhensifLain,
                  name: "rkapPenghasilanKomperhensifLain",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.penghasilanKomperhensifLain,
                dataInput.rkapPenghasilanKomperhensifLain
              )}
            </td>
          </tr>
          <tr>
            <td>Dividen</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.deviden,
                  name: "deviden",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapDeviden,
                  name: "rkapDeviden",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>{rkapPercentage(dataInput.deviden, dataInput.rkapDeviden)}</td>
          </tr>
          <tr>
            <td>Komponen Ekuitas Lain</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.komponenEkuitasLain,
                  name: "komponenEkuitasLain",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapKomponenEkuitasLain,
                  name: "rkapKomponenEkuitasLain",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.komponenEkuitasLain,
                dataInput.rkapKomponenEkuitasLain
              )}
            </td>
          </tr>
          <tr>
            <td>Kepentingan Non Pengendali</td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.kepentinganNonPengendali,
                  name: "kepentinganNonPengendali",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              <InputFieldResponsive2
                inputType={{
                  disabled: disabledInput,
                  value: dataInput.rkapKepentinganNonPengendali,
                  name: "rkapKepentinganNonPengendali",
                  type: "currency",
                }}
                onChange={handleChange}
              />
            </td>
            <td>
              {rkapPercentage(
                dataInput.kepentinganNonPengendali,
                dataInput.rkapKepentinganNonPengendali
              )}
            </td>
          </tr>
          <tr>
            <th>JUMLAH EKUITAS</th>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.ekuitas(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkapEkuitas(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              {rkapPercentage(
                formula.ekuitas(dataInput),
                formula.rkapEkuitas(dataInput)
              )}
            </td>
          </tr>
          <tr>
            <th>JUMLAH LIABILITAS DAN EKUITAS</th>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.jumlahLiabilitasEkuitas(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              <span className="d-flex">
                <h5 className="mt-0 ">
                  Rp. {numeral(formula.rkapJumlahLiabilitasEkuitas(dataInput)).format(0, 0)}
                </h5>
              </span>
            </td>
            <td>
              {rkapPercentage(
                formula.jumlahLiabilitasEkuitas(dataInput),
                formula.rkapJumlahLiabilitasEkuitas(dataInput)
              )}
            </td>
          </tr>
          <tr>
            <td>Catatan</td>
            <td>
              <InputFieldResponsive2
                label="Catatan"
                inputType={{
                  disabled: disabledInput,
                  type: "textarea",
                  name: "catatan",
                  value: dataInput.catatan,
                }}
                onChange={handleChange}
              />
            </td>
          </tr>
        </tbody>
      </Table>

      {/* <div className="mb-3">
        <h5>ASET LANCAR</h5>
        <InputFieldResponsive
          label="Kas dan Setara Kas"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.kas,
            name: "kas",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Investasi / Surat Berharga Jangka Pendek"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.investasiJangkaPendek,
            name: "investasiJangkaPendek",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <h5>Piutang Usaha</h5>
        <InputFieldResponsive
          label="Pihak Berelasi"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.puPihakBerelasi,
            name: "puPihakBerelasi",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Pihak Ketiga"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.puPihakKetiga,
            name: "puPihakKetiga",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <h5>Piutang Lain-lain</h5>
        <InputFieldResponsive
          label="Pihak Berelasi"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.plPihakBerelasi,
            name: "plPihakBerelasi",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Pihak Ketiga"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.plPihakKetiga,
            name: "plPihakKetiga",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Persediaan"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.persediaan,
            name: "persediaan",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Uang Muka Operasional"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.uangMukaOperasional,
            name: "uangMukaOperasional",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Uang Muka Proyek"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.uangMukaProyek,
            name: "uangMukaProyek",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Pendapatan yang Masih Harus Diterima"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.pendapatanHarusDiterima,
            name: "pendapatanHarusDiterima",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Biaya Dibayar Dimuka"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.biayaDibayarDimuka,
            name: "biayaDibayarDimuka",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Pajak Dibayar Dimuka"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.pajakDibayarDimuka,
            name: "pajakDibayarDimuka",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Aset Jaminan"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.asetJaminan,
            name: "asetJaminan",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Bagian Piutang Jangka Panjang yang Akan Jatuh "
          inputType={{
            disabled: user.role < 4,
            value: dataInput.pjpJatuhTempo,
            name: "pjpJatuhTempo",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Aset Lancar Lainnya"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.asetLancarLainnya,
            name: "asetLancarLainnya",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <span className="d-flex">
          <h5>Jumlah Aset Lancar</h5>
          <h5 className="mt-0 ml-auto">
            Rp. {numeral(formula.currentAsset(dataInput)).format(0, 0)}
          </h5>
        </span>
      </div>
      <hr />

      <div className="mb-3">
        <h5>ASET TIDAK LANCAR</h5>
        <InputFieldResponsive
          label="Aset Tetap - Bersih"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.asetTetapBersih,
            name: "asetTetapBersih",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Aset Tak Berwujud - Bersih"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.asetTakBerwujud,
            name: "asetTakBerwujud",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Aset Hak Guna"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.asetHakGuna,
            name: "asetHakGuna",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Aset Tanah dalam Pengembangan"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.asetTanahPengembangan,
            name: "asetTanahPengembangan",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Aset Dalam Penyelesaian"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.asetDalamPenyelesaian,
            name: "asetDalamPenyelesaian",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <h5>Piutang Jangka Panjang</h5>
        <InputFieldResponsive
          label="Pihak Berelasi"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.pjpPihakBerelasi,
            name: "pjpPihakBerelasi",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Pihak Ketiga"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.pjpPihakKetiga,
            name: "pjpPihakKetiga",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Uang Muka Pembelian Aset Tetap"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.umpAsetTetap,
            name: "umpAsetTetap",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Investasi Jangka Panjang"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.investasiJangkaPanjang,
            name: "investasiJangkaPanjang",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Investasi pada Entitas Asosiasi"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.investasiEntitasAsosiasi,
            name: "investasiEntitasAsosiasi",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Persediaan Real Estate"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.persediaanRealEstate,
            name: "persediaanRealEstate",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Properti Investasi - Bersih"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.propertiInvestasiBersih,
            name: "propertiInvestasiBersih",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Aset Pajak Tangguhan"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.asetPajakTangguhan,
            name: "asetPajakTangguhan",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Taksiran Tagihan Restitusi Pajak"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.taksiranRestitusiPajak,
            name: "taksiranRestitusiPajak",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Aset Pengampunan Pajak"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.asetPengampunanPajak,
            name: "asetPengampunanPajak",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Cadangan Imbalan Pasca Kerja"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.cadanganImbalanKerja,
            name: "cadanganImbalanKerja",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Aset Tidak Lancar Lainnya"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.asetTidaklancarLainnya,
            name: "asetTidaklancarLainnya",
            type: "currency",
          }}
          onChange={handleChange}
        />

        <span className="d-flex">
          <h5>Jumlah Aset Tidak Lancar</h5>
          <h5 className="mt-0 ml-auto">
            Rp. {numeral(formula.fixedAsset(dataInput)).format(0, 0)}
          </h5>
        </span>
        <hr />
        <span className="d-flex">
          <h5>JUMLAH ASET</h5>
          <h5 className="mt-0 ml-auto">
            Rp. {numeral(formula.jumlahAset(dataInput)).format(0, 0)}
          </h5>
        </span>
      </div>
      <hr /> */}


      {/* <div className="mb-3">
        <h5>LIABILITAS</h5>
        <h5>LIABILITAS JANGKA PENDEK</h5>
        <InputFieldResponsive
          label="Utang Bank Jangka Pendek"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.utangBankPendek,
            name: "utangBankPendek",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <h5>Utang Usaha</h5>
        <InputFieldResponsive
          label="Pihak Berelasi"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.uuPihakBerelasi,
            name: "uuPihakBerelasi",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Pihak Ketiga"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.uuPihakKetiga,
            name: "uuPihakKetiga",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <h5>Utang Lain-lain</h5>
        <InputFieldResponsive
          label="Pihak Berelasi"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.ulPihakBerelasi,
            name: "ulPihakBerelasi",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Pihak Ketiga"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.ulPihakKetiga,
            name: "ulPihakKetiga",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Utang Retensi Jangka Pendek"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.utangRetensiPendek,
            name: "utangRetensiPendek",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Utang Pajak "
          inputType={{
            disabled: user.role < 4,
            value: dataInput.utangPajak,
            name: "utangPajak",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Pendapatan Diterima Dimuka Jangka Pendek"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.pddPendek,
            name: "pddPendek",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Utang Dividen"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.utangDeviden,
            name: "utangDeviden",
            type: "currency",
          }}
          onChange={handleChange}
        /><InputFieldResponsive
          label="Utang Sewa"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.utangSewa,
            name: "utangSewa",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Biaya yang Masih Harus Dibayar Jangka Pendek"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.biayaDibayarPendek,
            name: "biayaDibayarPendek",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Bagian Utang Bank yang Akan Jatuh Tempo"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.bubJatuhTempo,
            name: "bubJatuhTempo",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Liabilitas Jangka Pendek Lainnya"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.liabilitasPendekLainnya,
            name: "liabilitasPendekLainnya",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <span className="d-flex">
          <h5>Jumlah Liabilitas Jangka Pendek</h5>
          <h5 className="mt-0 ml-auto">
            Rp. {numeral(formula.liabilitasJangkaPendek(dataInput)).format(0, 0)}
          </h5>
        </span>
      </div>
      <hr />
      <div className="mb-3">
        <h5>LIABILITAS JANGKA PANJANG</h5>
        <InputFieldResponsive
          label="Utang Bank Jangka Panjang"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.utangBankPanjang,
            name: "utangBankPanjang",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <h5>Utang Lain-lain</h5>
        <InputFieldResponsive
          label="Pihak Berelasi"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.ulpPihakBerelasi,
            name: "ulpPihakBerelasi",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Pihak Ketiga"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.ulpPihakKetiga,
            name: "ulpPihakKetiga",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Pendapatan Diterima Dimuka Jangka Panjang"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.pddPanjang,
            name: "pddPanjang",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Pajak Tangguhan"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.pajakTangguhanNeraca,
            name: "pajakTangguhanNeraca",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Utang Retensi Jangka Panjang"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.utangRetensiPanjang,
            name: "utangRetensiPanjang",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Biaya yang Masih Harus Dibayar Jangka Panjang"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.biayaDibayarPanjang,
            name: "biayaDibayarPanjang",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Utang Pembiayaan Jangka Panjang"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.utangPembiayaanPanjang,
            name: "utangPembiayaanPanjang",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Liabilitas Imbalan Pasca Kerja"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.liabilitasImbalanKerja,
            name: "liabilitasImbalanKerja",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Titipan Dana Pelepasan Aset"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.titipanPelepasanAset,
            name: "titipanPelepasanAset",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Utang Lain-lain Dalam Penyelesaian"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.utangLainPenyelesaian,
            name: "utangLainPenyelesaian",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Liabilitas Jangka Panjang Lainnya"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.liabilitasPanjangLainnya,
            name: "liabilitasPanjangLainnya",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <span className="d-flex">
          <h5>Jumlah Liabilitas Jangka Panjang</h5>
          <h5 className="mt-0 ml-auto">
            Rp. {numeral(formula.liabilitasJangkaPanjang(dataInput)).format(0, 0)}
          </h5>
        </span>
        <hr />
        <span className="d-flex">
          <h5>JUMLAH LIABILITAS</h5>
          <h5 className="mt-0 ml-auto">
            Rp. {numeral(formula.liabilitas(dataInput)).format(0, 0)}
          </h5>
        </span>
      </div>
      <hr />

      <div className="mb-3">
        <h5>EKUITAS</h5>
        <InputFieldResponsive
          label="Modal Saham"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.modalSaham,
            name: "modalSaham",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Tambahan Modal Disetor"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.tambahanModalDisetor,
            name: "tambahanModalDisetor",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Cadangan Modal"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.cadanganModal,
            name: "cadanganModal",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <h5>Saldo Laba Rugi</h5>
        <InputFieldResponsive
          label="Telah Ditentukan Penggunaannya"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.telahDitentukanPenggunaan,
            name: "telahDitentukanPenggunaan",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Belum Ditentukan Penggunaannya"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.belumDitentukanPenggunaan,
            name: "belumDitentukanPenggunaan",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Penghasilan Komprehensif Lain"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.penghasilanKomperhensifLain,
            name: "penghasilanKomperhensifLain",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Dividen"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.deviden,
            name: "deviden",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Komponen Ekuitas Lain"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.komponenEkuitasLain,
            name: "komponenEkuitasLain",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <InputFieldResponsive
          label="Kepentingan Non Pengendali"
          inputType={{
            disabled: user.role < 4,
            value: dataInput.kepentinganNonPengendali,
            name: "kepentinganNonPengendali",
            type: "currency",
          }}
          onChange={handleChange}
        />
        <span className="d-flex">
          <h5>JUMLAH EKUITAS</h5>
          <h5 className="mt-0 ml-auto">
            Rp. {numeral(formula.ekuitas(dataInput)).format(0, 0)}
          </h5>
        </span>
        <hr />
        <span className="d-flex">
          <h5>JUMLAH LIABILITAS DAN EKUITAS</h5>
          <h5 className="mt-0 ml-auto">
            Rp. {numeral(formula.jumlahLiabilitasEkuitas(dataInput)).format(0, 0)}
          </h5>
        </span>
      </div>
      <hr />
      <div className="mb-3">
        <InputFieldResponsive
          label="Catatan"
          inputType={{
            disabled: user.role < 4,
            type: "textarea",
            name: "catatan",
            value: dataInput.catatan,
          }}
          onChange={handleChange}
        />
      </div> */}

      {user.role >= 4 && (
        <Button
          color="blue"
          disabled={props.isLoadingButton}
          loading={props.isLoadingButton}
          onClick={handleSubmit}
        >
          Simpan
        </Button>
      )}
    </>
  );
};
